import { Alert, Icons } from '@commenda/kakashi';
import { TWorkRequest } from '@commenda/types/src/work-request/types';
import { WorkRequestHelper } from '@commenda/utils';
import { useRouter } from 'next/router';

const IncorporationInProgressAlert = ({
  businessEntityId,
  workRequests,
}: {
  businessEntityId: number;
  workRequests: TWorkRequest[];
}) => {
  const router = useRouter();

  const incorporationWorkRequests = workRequests.filter(
    (workRequest) =>
      WorkRequestHelper.isIncorporationWorkRequest(workRequest.type) &&
      workRequest.corporationDetails?.corporationId === businessEntityId
  );

  const incorporationWorkRequest = incorporationWorkRequests[0];

  const incorporationInProgressLink = incorporationWorkRequest?.id
    ? incorporationWorkRequest?.task?.taskGroup
        ?.serviceRequestId
      ? `/service-request/${incorporationWorkRequest?.task?.taskGroup?.serviceRequestId}`
      : WorkRequestHelper.getIncorporationWorkRequestLink(
          incorporationWorkRequest.type,
          incorporationWorkRequest.id
        )
    : null;

  return (
    <Alert
      title="Incorporation in progress"
      description="You can edit or add entity details and documents once incorporation is complete."
      variant="warning"
      icon={<Icons.Hourglass01 className="size-5 text-fg-warning" />}
      {...(incorporationInProgressLink
        ? {
            action: {
              label: 'View service details',
              onClick: () => router.push(incorporationInProgressLink),
              variant: 'link',
              size: 'sm',
            },
          }
        : {})}
    />
  );
};

export { IncorporationInProgressAlert };
